'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _draftJs = require('draft-js');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Checkbox = require('./Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _dependencies = require('../../../dependencies');

require('./ChecklistEditorBlock.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Components


// Utils


// Styles


/**
 * Renders a checklist block level item to the list.
 *  _
 * | | Some text goes here.
 *  —
 */
var ChecklistEditorBlock = function (_React$Component) {
    _inherits(ChecklistEditorBlock, _React$Component);

    function ChecklistEditorBlock() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ChecklistEditorBlock);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChecklistEditorBlock.__proto__ || Object.getPrototypeOf(ChecklistEditorBlock)).call.apply(_ref, [this].concat(args))), _this), _this.toggleChecked = function (event) {
            var _this$props = _this.props,
                blockProps = _this$props.blockProps,
                block = _this$props.block;
            var updateMetadataFn = blockProps.updateMetadataFn,
                returnFocusToEditor = blockProps.returnFocusToEditor,
                checked = blockProps.checked;


            if (!blockProps.isEditable) return;

            event.stopPropagation();

            var newChecked = !checked;
            updateMetadataFn(block, { checked: newChecked });

            returnFocusToEditor();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    /**
     * Toggles the internal state of 'checked' as well as updating the editor's metadata for this block.
     * If the block becomes unchecked we delete the entry from the metadata map to prevent it from growing too large.
     */


    _createClass(ChecklistEditorBlock, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                offsetKey = _props.offsetKey,
                blockProps = _props.blockProps;
            var checked = blockProps.checked;


            var blockClassNames = (0, _classnames2.default)('ChecklistEditorBlock', { checked: checked });

            return _react2.default.createElement(
                'div',
                { className: blockClassNames, 'data-offset-key': offsetKey },
                _react2.default.createElement(_Checkbox2.default, { checked: checked, onMouseDown: this.toggleChecked, onClick: _dependencies.stopPropagationOnly }),
                _react2.default.createElement(
                    'div',
                    { className: 'text' },
                    _react2.default.createElement(_draftJs.EditorBlock, this.props)
                )
            );
        }
    }]);

    return ChecklistEditorBlock;
}(_react2.default.Component);

exports.default = ChecklistEditorBlock;


ChecklistEditorBlock.propTypes = {
    block: _propTypes2.default.object.isRequired,
    blockProps: _propTypes2.default.object.isRequired,
    offsetKey: _propTypes2.default.string.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/checklist/components/ChecklistEditorBlock.js
// module id = 1721
// module chunks = 0